export default __webpack_public_path__ + "static/media/13.743228c9.jpg";